(function() {
  'use strict';
  
  angular
    .module('plugins.word-cloud')
    .directive('wordCloud', wordCloud);
      
  wordCloud.$inject = [
    '$log', 
    '$compile', 
    '$q', 
    '$window', 
    'plugins'
  ];
    
  function wordCloud(
      $log, 
      $compile,
      $q, 
      $window, 
      plugins
    ) {
    $log = $log.getInstance('wordCloud');
    
    var cloud;
    var onResizeDebounced = _.debounce(onResize, 300);
    var onWordsChangedThrottled = _.throttle(onWordsChanged, 2000);

    var directive = {
      link: link,
      restrict: 'EA',
      scope: {
        words: '='
      },
    }
    return directive;
    
    function link(scope, element, attrs) {      
      plugins.loadScript('assets/libs/d3/d3.min.js', 'd3')
        .then(function() {
          return plugins.loadScript('assets/libs/word-cloud/word-cloud.js', 'wordCloud');
        })
        .then(function() {
          // MARS color scheme
          var fill = d3.scaleOrdinal([
            '#f44336', '#00BCD4', '#FFC107', '#607D8B', '#673AB7',
            '#2196F3', '#03A9F4', '#3F51B5', '#009688', '#4CAF50',
            '#8BC34A', '#CDDC39', '#FFEB3B', '#E91E63', '#FF9800',
            '#FF5722', '#795548', '#9E9E9E', '#9C27B0'
          ]);
          // Create the cloud
          cloud = new SLC3.WordCloud()
            .font('roboto')
            .fill(function(d, i) { return fill(i); })
            .size(function() {
              var computed = $window.getComputedStyle(cloud.element());
              var width = parseInt(computed.width, 10);
              var height = $window.innerHeight - 320;
              return [width, height];
            });
          element.append(cloud.element());
          // Re-render the layout when the window is resized
          angular.element($window).bind('resize', onResizeDebounced);
          scope.$on('$destroy', function() {
            angular.element($window).unbind('resize', onResizeDebounced);
          });
          // Re-render the layout when scope.words is changed
          scope.$watch('words', onWordsChangedThrottled, true);
        });
    }

    function onResize() {
      cloud.render();
    }

    function onWordsChanged(newWords, oldWords) {
      $log.info('newWords = ', newWords);
      if (!angular.isArray(newWords))
        return;
      var words = _.sortBy(
        angular.copy(newWords), 
        function(d) { return d.frequency }
      );
      cloud.words(words).render();
    }
    
  }
  
})();